(() => {
  angular.module('app').component('outpatientClaimQueryComponent', {
    templateUrl: require('./query.component.html'),
    controller: OutpatientClaimQueryController,
    controllerAs: 'vm',
    bindings: {
      claimNumber: '<',
      newRepliedQueriesCount: '=',
      newQueriesCount: '=',
      timeZoneId: '<'
    },
  });

  OutpatientClaimQueryController.$inject = [
    '$scope',
    '$rootScope',
    '$timeout',
    '$state',
    '$location',
    'abp.services.app.serviceRequestQuery',
    'appConstants',
  ];

  function OutpatientClaimQueryController(
    $scope,
    $rootScope,
    $timeout,
    $state,
    $location,
    serviceRequestQuerySvc,
    appConstants
  ) {
    const vm = this;
    vm.loading = 0;
    vm.saving = 0;
    vm.isHost = App.isHost();
    vm.isSpecialist = App.isSpecialist();
    vm.isHealthScreening = App.isHealthScreening();
    vm.claimType = null;

    const viewOptions = {
      maxResultCount: appConstants.grid.defaultPageSize,
      skipCount: 0,
      sorting: null,
    };

    vm.replyQuery = replyQuery;
    vm.viewQuery = viewQuery;
    vm.getDateTimeString = getDateTimeString;

    init();

    function init() {
      $timeout(() => {
        vm.queryComponentGridOptions.paginationCurrentPage = Math.floor(
          viewOptions.skipCount / viewOptions.maxResultCount + 1
        );
      });

      // Getting claim type.
      const currentUrl = $location.path().split('/');

      let claimType = null;
      claimType = currentUrl[1] === 'clinic' ? currentUrl[2] : currentUrl[3];
      initClaimType(claimType);
    }

    function initClaimType(claimType) {
      switch (claimType) {
        case 'healthScreening':
          vm.claimType = 'healthScreening';
          break;
        case 'specialist':
          vm.claimType = 'specialist';
          break;

        // no default
      }
    }

    vm.queryComponentGridOptions = {
      appScopeProvider: vm,
      paginationPageSizes: appConstants.grid.defaultPageSizes,
      paginationPageSize: appConstants.grid.defaultPageSize,
      paginationCurrentPage: 0,
      useExternalPagination: true,
      useExternalSorting: true,
      resizable: true,
      columnDefs: [
        {
          name: 'Actions',
          displayName: 'Actions',
          enableSorting: false,
          width: 75,
          headerCellTemplate: '<span></span>',
          cellTemplate: 'queryComponentViewTemplate',
        },
        {
          displayName: App.localize('QueryNumber'),
          field: 'queryNumber',
          minWidth: 100,
          width: 150,
        },
        {
          displayName: App.localize('CreationTime'),
          enableSorting: false,
          field: 'creationTime',
          minWidth: 120,
          cellTemplate: 'creationTimeTemplate'
        },
        {
          displayName: App.localize('RepliedBy'),
          enableSorting: false,
          field: 'repliedUserName',
          minWidth: 120,
        },
        {
          displayName: App.localize('ReplyTime'),
          enableSorting: false,
          field: 'repliedTime',
          minWidth: 120,
          cellTemplate: 'repliedTimeTemplate'
        },
        {
          displayName: App.localize('ResolvedBy'),
          enableSorting: false,
          field: 'resolvedUserName',
          minWidth: 120,
        },
        {
          displayName: App.localize('ResolvedAt'),
          enableSorting: false,
          field: 'resolvedTime',
          minWidth: 120,
          cellTemplate: 'resolvedTimeTemplate'
        },
        {
          displayName: App.localize('CreatorUserName'),
          enableSorting: false,
          field: 'creatorUserName',
          minWidth: 120,
        },
      ],
      onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;

        $scope.gridApi.core.on.sortChanged($scope, (scope, callback) => {
          viewOptions.sorting =
            callback.length && callback[0].field
              ? `${callback[0].field} ${callback[0].sort.direction}`
              : null;
          getQueries();
        });
        gridApi.pagination.on.paginationChanged($scope, App.setPagination(viewOptions, getQueries));
      },
      data: [],
    };

    function getQueries() {
      vm.loading += 1;
      serviceRequestQuerySvc
        .getQueries({
          claimNumber: vm.claimNumber,
          skipCount: viewOptions.skipCount,
          maxResultCount: viewOptions.maxResultCount,
        })
        .success((data) => {
          vm.queryComponentGridOptions.totalItems = data.queries.totalCount;
          vm.queryComponentGridOptions.data = data.queries.items;
          vm.canCreateQuery = data.canCreateQuery;
          vm.newRepliedQueriesCount = data.newRepliedQueriesCount;
          vm.newQueriesCount = data.newQueriesCount;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function viewQuery(queryNumber, claimNumber, timeZoneId) {
      // TODO: Migrate specialist claim query here.
      switch (vm.claimType) {
        case 'healthScreening':
          $state.go('viewHealthScreeningQuery', {
            queryNumber,
            claimNumber,
            timeZoneId
          });
          break;

        // no default
      }
    }

    function replyQuery(queryNumber, claimNumber, timeZoneId) {
      // TODO: Migrate specialist claim query here.
      switch (vm.claimType) {
        case 'healthScreening':
          $state.go('clinic.replyHealthScreeningQuery', {
            queryNumber,
            claimNumber,
            timeZoneId
          });
          break;

        // no default
      }
    }

    function getDateTimeString(date, timeZoneId) {
      return App.getDateTimeString(date, timeZoneId);
    }
  }
})();
